export default __webpack_public_path__ + "static/media/agac.c14fbe34.png";